var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/circleci/project/@static/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["@modules/modals/templates/select-shuttle-view.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"modal-inner-container shuttle-select ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSize"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsPadding"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsBackgroundColor"), env.opts.autoescape);
output += "\">\n    <button class=\"modal__close-btn btn\" data-js-ui=\"close-modal\">\n        <span class=\"modal__close-btn-label\" data-auto-translate=\"true\">Close</span>\n        <span class=\"modal__close-btn-icon icon-close\"></span>\n    </button>\n    <div class=\"container-fluid\">\n        <div class=\"row\">\n            <div class=\"col-12\">\n                <div class=\"headline\" data-auto-translate=\"true\">\n                    Select a performance to view Park &amp; Ride / Bowl Shuttle options:\n                </div>\n                <div class=\"filters filters--other-performances\" data-js-view=\"other-performances-filter\">\n                    <form action=\"?q=\" class=\"filter-form\" data-js-ui=\"filter-form\">\n                        <div class=\"filter-dropdown filter-wrapper\">\n                            <select class=\"filter\" onchange=\"if (this.value) window.location.href=this.value\" name=\"type\" id=\"type\" data-js-ui=\"select-filter\" data-js-select2 data-select-placeholder=\"Select Concert\">\n                                <option value=\"\" data-auto-translate=\"true\">Select Concert</option>\n                                <optgroup>\n                                ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "jsRelatedPerformances");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("perf", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                                    <option value=\"/events/performances/";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "/park-and-ride/\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "</option>\n                                ";
;
}
}
frame = frame.pop();
output += "\n                                </optgroup>\n                            </select>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["@modules/modals/templates/select-shuttle-view.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./@modules/modals/templates/select-shuttle-view.njk
// module id = 484
// module chunks = 0